import React from "react";
import { Checkbox as AntCheckbox, Form } from "antd";

import * as values from "values";
import Checkbox, { renderCheckboxes } from "Form/Checkbox";
import { MapAndLocation, Prices, PropertiesCondition, TotalSize } from "Components/Filters/FilterComponents";
import { CommercialFilter, CommercialOffer, FilterTypes, PropertyTypes } from "Types";
import FilterComponent from "./Filter";

const CommercialsFilter = (): JSX.Element => {
    return (
        <FilterComponent<CommercialOffer, CommercialFilter>
            type={FilterTypes.commercials}
            label={values.OfferTypeNames.commercial}
        >
            {(formik, filter): JSX.Element => (
                <>
                    <Form.Item label={"Typ"}>
                        <AntCheckbox.Group className={"rmxo-checkbox-group"}>
                            {renderCheckboxes(values.availableCommercialTypes, "commercialPropertyTypes", formik)}
                            <Checkbox
                                setValue={formik.setFieldValue}
                                name={"typeOfProperties[8]"}
                                value={{
                                    id: PropertyTypes.housesToRent,
                                    value: "Nájemní domy",
                                    urlValue: "najemni-domy",
                                }}
                                label={"Nájemní domy"}
                            />
                            {renderCheckboxes(values.availableHospitalityTypes, "hospitalityTypes", formik)}
                        </AntCheckbox.Group>
                    </Form.Item>
                    <PropertiesCondition formik={formik} />
                    <MapAndLocation formik={formik} filter={filter} />

                    <Prices />
                    <Form.Item label={"Další"}>
                        <AntCheckbox.Group className={"rmxo-checkbox-group"}>
                            <Checkbox
                                setValue={formik.setFieldValue}
                                name={"parking"}
                                value={true}
                                label={"Parkování"}
                            />
                            <Checkbox setValue={formik.setFieldValue} name={"garage"} value={true} label={"Garáž"} />
                        </AntCheckbox.Group>
                    </Form.Item>
                    <TotalSize />
                </>
            )}
        </FilterComponent>
    );
};

export default CommercialsFilter;
